document.addEventListener("scroll", function () {
    document.querySelectorAll(".parallax-hero").forEach(section => {
        const rect = section.getBoundingClientRect();
        const offset = window.innerHeight - rect.top;
        section.style.backgroundPositionY = offset * 0.3 + "px";
    });
});